export const RESCHEDULE_SLOT_MODEL = "reschedule-slot";

const rescheduleSlotModel = {
  slotToAdd: {},
  slotToRemove: "",
  reason: ""
};

export default rescheduleSlotModel;
